import _merge from 'lodash/merge';
import { STRINGS as CONSTANTS } from './constants';
import { primaryCareConfig } from './primaryCare';
import { eTriageConfig } from './eTriage';
import { eSpecialistConfig } from './eSpecialist';

const environment = process.env.REACT_APP_ENVIRONMENT;

const getEnvironment = () => {
  switch (environment) {
    case 'production':
      return primaryCareConfig.productionConfig;
    case 'test':
      return primaryCareConfig.testConfig;
    case 'staging':
      return primaryCareConfig.stagingConfig;
    case 'development':
      return primaryCareConfig.developmentConfig;
    case 'demo':
      return primaryCareConfig.demoConfig;
    case 'production-etriage':
      return eTriageConfig.productionConfig;
    case 'test-etriage':
      return eTriageConfig.testConfig;
    case 'staging-etriage':
      return eTriageConfig.stagingConfig;
    case 'development-etriage':
      return eTriageConfig.developmentConfig;
    case 'demo-etriage':
      return eTriageConfig.demoConfig;
    case 'production-especialist':
      return eSpecialistConfig.productionConfig;
    case 'test-especialist':
      return eSpecialistConfig.testConfig;
    case 'staging-especialist':
      return eSpecialistConfig.stagingConfig;
    case 'development-especialist':
      return eSpecialistConfig.developmentConfig;
    case 'demo-especialist':
      return eSpecialistConfig.demoConfig;
    case 'dte':
      return primaryCareConfig.dynamicConfig;
    default:
      return {};
  }
};

export const STRINGS = _merge({}, CONSTANTS, getEnvironment());

let dynamicTestEnvironmentURLs = {};

export const addDynamicTestEnvironmentURLs = (dynamicEnvironmentURLs = {}) => {
  dynamicTestEnvironmentURLs = dynamicEnvironmentURLs;
};

/* Unlike getEnvironment() this returns a function */
const getDynamicTestEnvironmentConfig = () => {
  switch (environment) {
    case 'dte': // from elite .env
    case 'test':
      return primaryCareConfig.dynamicConfig;
    case 'test-etriage':
      return eTriageConfig.dynamicConfig;
    case 'test-especialist':
      return eSpecialistConfig.dynamicConfig;
    default:
      return () => {};
  }
};

const dynamicTestEnvironmentConfig = getDynamicTestEnvironmentConfig(dynamicTestEnvironmentURLs);

export const createDynamicStrings = () => {
  if (dynamicTestEnvironmentURLs.apiBaseURL && dynamicTestEnvironmentURLs.webappURL) {
    return _merge(STRINGS, dynamicTestEnvironmentConfig(dynamicTestEnvironmentURLs));
  }
  return STRINGS;
};
